// extracted by mini-css-extract-plugin
export default {"dot":"o5SaExdn","active":"AbNx6lmU","pulse":"fEL8h03t","inactive":"r1Ak9oTF"};